import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment, a as Host } from './index.js';
import { s as slotFilled } from './p-rUtJRH95.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$j } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$i } from './p-C-AXl3sC.js';
import { d as defineCustomElement$h } from './p-CDhEAnE1.js';
import { d as defineCustomElement$g } from './p-VRJNF0zT.js';
import { d as defineCustomElement$f } from './p-D-k_i6-R.js';
import { d as defineCustomElement$e } from './p-DMseB40X.js';
import { d as defineCustomElement$d } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$c } from './p-D4xpFZtu.js';
import { d as defineCustomElement$b } from './p-Brrpvenv.js';
import { d as defineCustomElement$a } from './p-Cy8qWWQl.js';
import { d as defineCustomElement$9 } from './p-DLWyhg_S.js';
import { d as defineCustomElement$8 } from './p-BqzjvfBR.js';
import { d as defineCustomElement$7 } from './p-DE-WBrSS.js';
import { d as defineCustomElement$6 } from './p-C1O8YWIG.js';
import { d as defineCustomElement$5 } from './p-aqq22Qbe.js';
import { d as defineCustomElement$4 } from './p-X4ah_kdd.js';
import { d as defineCustomElement$3 } from './p-BqnaoLp8.js';
import { d as defineCustomElement$2 } from './p-B4Sv5V7D.js';

const topNavCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host nav{align-content:center;align-items:center;background-color:var(--jw-theme-surface-elevated-default-bg-color);display:flex;flex:1 0 0;flex-wrap:wrap;gap:.75rem;justify-content:space-between;padding:.75rem 1.5rem}.user-menu-container{align-content:center;align-items:center;display:flex;gap:.125rem}.center-slot-container{flex-grow:1;max-width:var(--jw-container-md);min-width:var(--jw-container-xs);width:80%}.right-slot-container{align-items:center;display:flex;gap:.75rem;justify-content:center}";

const WuiTopNav$1 = /*@__PURE__*/ proxyCustomElement(class WuiTopNav extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.menuOpenChanged = createEvent(this, "menuOpenChanged", 7);
        /**
         * Controls if user menu is open
         */
        this.menuOpen = false;
    }
    toggleOpen(open = !this.menuOpen) {
        if (open === this.menuOpen) {
            return;
        }
        this.menuOpen = open;
        this.menuOpenChanged.emit(this.menuOpen);
    }
    getRightSideSlots() {
        return Array.from(this.elm.querySelectorAll('[slot="right-side-content"]')).map((elem) => (h("span", { innerHTML: elem.outerHTML })));
    }
    getStatusIndicator() {
        if (!this.statusIndicator) {
            return null;
        }
        return h("wui-tag", { ...this.statusIndicator });
    }
    getUserMenu() {
        if (!this.userMenu) {
            return null;
        }
        const { signoutButton, status, sections, ...rest } = this.userMenu;
        return (h("div", { class: "user-menu-container" }, status && h("wui-status", { ...status, intent: "warning", type: "icon" }), h("wui-more-menu", { ...rest, buttonType: "ghost", icon: this.menuOpen ? 'chevron-up' : 'chevron-down', iconPosition: "trailing", disabled: sections.length === 0, closeOnClickInside: true, menuPane: {
                placement: 'bottom-end',
                stretch: 'off',
            } }, h("wui-list", { class: "user-menu" }, sections.map((section) => {
            const { title, links } = section;
            return (h(Fragment, null, title && h("wui-list-item-header", { key: `section-title-${title}-${links.length}`, label: title }), links.map((link) => {
                return h("wui-list-item", { ...link, key: `user-menu-${link.label}`, as: ['a', parseHrefProp(link)] });
            }), h("wui-list-item-divider", null)));
        }), signoutButton && h("wui-list-item", { ...signoutButton, label: signoutButton.label || 'Sign out' })))));
    }
    renderRightSideContent() {
        const slots = this.getRightSideSlots();
        const userMenu = this.getUserMenu();
        const statusIndicator = this.getStatusIndicator();
        const rightContentElements = [statusIndicator, ...slots, userMenu].filter(Boolean);
        return (h("section", { class: "right-slot-container" }, rightContentElements.map((element, idx) => {
            return (h(Fragment, null, element, idx !== rightContentElements.length - 1 && h("wui-divider", { type: "vertical" })));
        })));
    }
    render() {
        return (h(Host, { key: 'bd5ffe999822b07c1e75620872163aa06162f6ae' }, h("nav", { key: 'f877183cfdef46236c6c959297832f5256b688e2' }, h("section", { key: 'ed38c5f87a5bccabf34cb1ac0ed0c57aa4cb31b5', class: "left-slot-container" }, h("slot", { key: '6cfc0e380b6e5fee898c3695a164713d3f15a256', name: "left-side-content" })), slotFilled(this.elm, 'center-content') && (h("section", { key: '2930840cfda3a7a902f75e6023caddd9e1bf15b1', class: "center-slot-container" }, h("slot", { key: '40c309a1bcf7aefdf85ebcc53d4b3d86d5948bee', name: "center-content" }))), this.renderRightSideContent())));
    }
    get elm() { return this; }
    static get style() { return topNavCss; }
}, [257, "wui-top-nav", {
        "userMenu": [16, "user-menu"],
        "statusIndicator": [16, "status-indicator"],
        "menuOpen": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-top-nav", "wui-box", "wui-button", "wui-check-input", "wui-close-button", "wui-divider", "wui-form-field", "wui-icon", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-loader", "wui-menu-pane", "wui-more-menu", "wui-status", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-top-nav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTopNav$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTopNav = WuiTopNav$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTopNav, defineCustomElement };
